import React, {FC} from 'react';
import './style.scss';
import CompilationsGroupCard from '../CompilationsGroupCard';
import {ICompilation} from "../../../constants/types";

interface ICompilations {
    ourCompilations: Array<ICompilation>,
    hookahCompilations: Array<ICompilation>,
    authorCompilations: Array<ICompilation>,
    setIndexCompilations: any,
    fetchMixCompilation: any,
    setCurrentCompilations: any
}

const Collections: FC<ICompilations> = ({
                                            ourCompilations,
                                            hookahCompilations,
                                            authorCompilations,
                                            setIndexCompilations,
                                            fetchMixCompilation,
                                            setCurrentCompilations
                                        }) => {

    return (
        <div className="collections">
            <div className="collections__list">
                <CompilationsGroupCard
                    title="Наши подборки"
                    compilations={ourCompilations}
                    setCurrentCompilations={setCurrentCompilations}
                    id={0}
                    idCompilations={ourCompilations[0].id}
                    fetchMixCompilation={fetchMixCompilation}
                    setIndexCompilations={setIndexCompilations}
                />
                <CompilationsGroupCard
                    title="Подборки: кальянные"
                    compilations={hookahCompilations}
                    setCurrentCompilations={setCurrentCompilations}
                    id={1}
                    idCompilations={hookahCompilations[0].id}
                    fetchMixCompilation={fetchMixCompilation}
                    setIndexCompilations={setIndexCompilations}
                />
                <CompilationsGroupCard
                    title="Подборки: авторские"
                    compilations={authorCompilations}
                    setCurrentCompilations={setCurrentCompilations}
                    id={2}
                    idCompilations={authorCompilations[0].id}
                    fetchMixCompilation={fetchMixCompilation}
                    setIndexCompilations={setIndexCompilations}
                />
            </div>
        </div>
    )
};

export default Collections;
